import React from 'react';

import { Link } from 'react-router-dom';

import { bemCssModules, getTestId } from '@utils';
import { useLocation } from '@utils/hooks';

import style from './CryptoMenu.scss';

const cn = bemCssModules(style, 'CryptoMenu');
const ti = getTestId('CryptoMenu');

export type TCryptoMenu = {
  activeTab: string;
  tabs: string[];
  onChange?: (tab: string) => void;
};

export const CryptoMenu: CustomFC<TCryptoMenu> = props => {
  const { activeTab, className, onChange, tabs } = props;

  const location = useLocation();
  const re = new RegExp(`/${activeTab}`, 'gi');
  const to = location.pathname.replace(re, '');

  const handleChange = (tab: (typeof tabs)[number]) => () => onChange?.(tab);

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      {tabs.map(item => (
        <Link
          key={item}
          onClick={handleChange(item)}
          className={cn('currency', { active: item === activeTab })}
          to={`${to}/${item}`}
        >
          {item}
        </Link>
      ))}
    </div>
  );
};

export default CryptoMenu;
